import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconLiveRateComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-LiveRate${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 48 48" fill="none" {...rest} ref={ref}><circle cx="24" cy="24" r="22" fill={useCurrentColor ? 'currentColor' : '#FFF6E2'}/><path d="M32.18 21.982a2.565 2.565 0 010 4.084l-10.071 7.653c-1.689 1.284-4.117.08-4.117-2.042V16.37c0-2.12 2.428-3.325 4.117-2.042l10.07 7.654z" fill={useCurrentColor ? 'currentColor' : '#FFC240'}/></svg>;
}

const IconLiveRate = React.forwardRef(IconLiveRateComponent);
export default IconLiveRate;
